import { IRowNode } from 'ag-grid-community';
import { DateTime } from 'luxon';

const getTimeValue = (time: string): number => {
  const pmAddendum = time.toUpperCase().includes('PM') ? 120000 : 0;
  return +time.replaceAll(/:|AM|PM|am|pm|\s/g, '') + pmAddendum;
};

export const comparators = {
  dateTimeComparator:
    (dateField = 'date', timeField = 'time') =>
    (_value1: string, _value2: string, node1: IRowNode, node2: IRowNode) => {
      const node1Date = node1.data[dateField];
      const node2Date = node2.data[dateField];
      const node1Time = node1.data[timeField] ?? '';
      const node2Time = node2.data[timeField] ?? '';

      if (!node1Date && node2Date) {
        return -1;
      }
      if (!node2Date && node1Date) {
        return 1;
      }
      if (!node1Date && !node2Date) {
        return getTimeValue(node1Time) - getTimeValue(node2Time);
      }

      const date1 = new Date(`${node1Date} ${node1Time}`);
      const date2 = new Date(`${node2Date} ${node2Time}`);

      if (date1 < date2) {
        return -1;
      } else if (date1 > date2) {
        return 1;
      }
      return 0;
    },
  numberComparator: (valueA: string, valueB: string): number => {
    const numA = +valueA;
    const numB = +valueB;
    const conditionA = isNaN(numA) || valueA === null || (typeof valueA === 'string' && valueA.trim() === '') ? -1 : 0;
    const conditionB = isNaN(numB) || valueB === null || (typeof valueB === 'string' && valueB.trim() === '') ? 1 : 0;

    if (conditionA + conditionB) {
      return conditionA || conditionB;
    }
    if (conditionA && conditionB) {
      valueA = valueA ?? '';
      valueB = valueB ?? '';
      return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
    }
    return numA < numB ? -1 : numA > numB ? 1 : 0;
  },
  // example:
  // a = "16:24:47", b = "08:34:49"  -> Benzinga time format
  // +"16:24:47".replaceAll(":", "") -> +"162447" -> 162447
  // +"08:34:49".replaceAll(":", "") -> +"083449" -> 83449
  // 162534 - 83449 > 0 -> sort be before a
  // previously: new Data("16:24:47") -> Invalid Date - this can't work
  timeComparator: (a: string, b: string): number => getTimeValue(a) - getTimeValue(b),
  timeStampComparator:
    (dateField = 'timestamp') =>
    (_value1: string, _value2: string, node1: IRowNode, node2: IRowNode) => {
      const node1Date = node1.data[dateField];
      const node2Date = node2.data[dateField];

      if (!node1Date && node2Date) {
        return -1;
      }
      if (!node2Date && node1Date) {
        return 1;
      }

      const date1 = DateTime.fromMillis(node1Date * 1000);
      const date2 = DateTime.fromMillis(node2Date * 1000);

      if (date1 < date2) {
        return -1;
      } else if (date1 > date2) {
        return 1;
      }
      return 0;
    },
};
